import React from "react";

const PromoBanner = () => {
  return (
    <div className="promo_banner">
      <div className="container">
        <div className="call_action">
          <div className="first">
            <h2>Ready to meet your personal AI writing assistant?</h2>
            <p>
              Take action now to make a difference! Whether it's supporting a
              cause you're passionate about
            </p>
            <button>Start Writing For Free</button>
          </div>
          <div className="second">
            <img src="/assets/call-to-action.webp" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
